export const getEditPosterURL = (hash: string): string => {
  return window.PMW.util.site_url(`posterbuilder/load/${hash}`);
};

export const getDuplicatePosterURL = (hash: string): string => {
  return window.PMW.util.site_url(`posterbuilder/copy/${hash}`);
}
